import { Component, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import _ from 'lodash';
import { SelectItem } from 'primeng/api/selectitem';



const AvailableIconsMap = {
  'fas fa-hiking': 'Hiking',
  'fas fa-paint-brush': 'Art',
  'fas fa-bed': 'Eco Lodge',
  'fas fa-campground': 'Desert Camping',
  'fas fa-walking': 'Walking Tour',
  'fas fa-running': 'Running',
  'fas fa-bus-alt': 'Transport',
  'fas fa-utensils': 'Food',
  'fas fa-tractor': 'Farming',
  'fas fa-fish': 'Fishing',
  'fas fa-monument': 'History',
  'fas fa-music': 'Music',
  'fas fa-mug-hot': 'Drinks',
  'fas fa-mosque': 'Mosque',
  'fas fa-church': 'Church',
  'fas fa-home': 'Home - Regular',
  'fas fa-igloo': 'Farm House',
  'fas fa-hotel': 'Hotel',
  'fas fa-bicycle': 'Cycling',
  'fas fa-camera': 'Photos',
  'fas fa-praying-hands': 'Hand Crafts',
  'fas fa-puzzle-piece': 'Games',
  'fas fa-ship': 'Boat trip',
  'fas fa-user-tie': 'Guide',
  'fas fa-comments': 'Consulting',
  'fas fa-plane': 'AirPlane',
  'fas fa-ticket-alt': 'Ticket',
  'fas fa-truck': 'Transport',
  'fas fa-hand-holding-usd' : 'Money',  
};


@Component({
  selector: 'app-included-input',
  templateUrl: './included-input.component.html',
  styleUrls: ['./included-input.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => IncludedInputComponent),
    },
  ],
})
export class IncludedInputComponent implements ControlValueAccessor {
  availableIcons = AvailableIconsMap;

  internalModel: Array<IncludedItem> = [];

  tempNgModel = {
    iconClasses: null,
    content: null,
  } as IncludedItem;

  availableIconKeys: Array<SelectItem> = [
    {
      label: 'Select Icon',
      value: null
    },
    ...Object.keys(AvailableIconsMap).map(key => ({ value: key, label: key }))
  ];
  private _touched = false;
  private _onChange = (v: any) => { };
  private _onTouched = (touched: boolean) => { };


  addItem() {
    if (this.tempNgModel.content && this.tempNgModel.iconClasses) {
      this.internalModel.push(_.cloneDeep(this.tempNgModel));
      this.tempNgModel = {
        iconClasses: null,
        content: null,
      };
      this.updateNgValue();
    }
  }

  removeItem(index) {
    this.internalModel.splice(index, 1);
    this.updateNgValue();
  }

  /**
   *
   * ng value accessor functions
   */
  writeValue(newVal) {
    this.internalModel = newVal || [];
  }

  registerOnChange(onChange) {
    this._onChange = onChange;
  }

  registerOnTouched(onTouched) {
    this._onTouched = onTouched;
  }

  private updateNgValue() {
    if (!this._touched) {
      this._touched = true;
      this._onTouched(this._touched);
    }
    console.log('updating value', this.internalModel);
    this._onChange(this.internalModel);
  }
}


interface IncludedItem {
  iconClasses: string;
  content: string;
}
